/**
 * FullscreenDatabaseNoteBlock
 *
 * Minimal note block for fullscreen database mode.
 * Renders only children (databases) without note-specific widgets
 * (KeyboardToolbar, etc.) that require VirtualKeyboardProvider.
 */

import type { NoteBlockModel } from '@blocksuite/affine/model';
import { BlockComponent } from '@blocksuite/affine/std';
import { html } from 'lit';

export class FullscreenDatabaseNoteBlock extends BlockComponent<NoteBlockModel> {
  override renderBlock() {
    return html`<div class="fullscreen-database-note">
      ${this.renderChildren(this.model)}
    </div>`;
  }
}
